import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type TicketsUIStore = {
    activeTab: number
    setActiveTab: (tab: number) => void
}

export const useTicketActiveTab = create<TicketsUIStore>()(
    persist(
        (set) => ({
            activeTab: 0,
            setActiveTab: (tab) => set({ activeTab: tab }),
        }),
        {
            name: 'tickets-active-tab-storage',
        }
    )
)